/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function() {

	return class TransactionUtil {
		static transactionTokenToOptions(transactionToken) {
			let oldOptions = {};
			if (transactionToken && transactionToken.transactionId) {
				oldOptions.payloadData = {
					undoRedoTransactionId: transactionToken.transactionId,
					transactionToken: transactionToken
				};
			}

			return oldOptions;
		}
	};
});